import React, { useEffect, useRef, useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
} from '@mui/material';
import { subscribeConfirm } from '../utils/functions/globalDialog';

// แทน window.confirm() — mount ครั้งเดียวที่ root (index.js) เหมือน GlobalErrorDialog
// resolveRef เก็บ resolve function ของ Promise ที่ confirmAsync() สร้างไว้ตอนเรียก เรียกตอนกดปุ่ม
const GlobalConfirmDialog = () => {
  const [message, setMessage] = useState(null);
  const resolveRef = useRef(null);

  useEffect(
    () => subscribeConfirm((msg, resolve) => {
      setMessage(msg);
      resolveRef.current = resolve;
    }),
    [],
  );

  const answer = (value) => {
    setMessage(null);
    resolveRef.current?.(value);
    resolveRef.current = null;
  };

  return (
    <Dialog
      open={!!message}
      onClose={() => answer(false)}
      maxWidth="xs"
      fullWidth
    >
      <DialogTitle>ยืนยันการทำรายการ</DialogTitle>
      <DialogContent>
        <DialogContentText style={{ whiteSpace: 'pre-wrap' }}>
          {message}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => answer(false)}>ยกเลิก</Button>
        <Button onClick={() => answer(true)} variant="contained" autoFocus>
          ยืนยัน
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default GlobalConfirmDialog;
